import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
import enCommon from './resources/en/common.json';
import enTarot from './resources/en/tarot.json';
import enUI from './resources/en/ui.json';
import enCards from './resources/en/cards.json';

import zhCommon from './resources/zh/common.json';
import zhTarot from './resources/zh/tarot.json';
import zhUI from './resources/zh/ui.json';
import zhCards from './resources/zh/cards.json';

export const defaultNS = 'common';

export const resources = {
  en: {
    common: enCommon,
    tarot: enTarot,
    ui: enUI,
    cards: enCards,
  },
  zh: {
    common: zhCommon,
    tarot: zhTarot,
    ui: zhUI,
    cards: zhCards,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    defaultNS,
    ns: ['common', 'tarot', 'ui', 'cards'],
    
    resources,
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    detection: {
      // First-time visitors start in English everywhere. A deliberate choice
      // in the language menu is still retained for return visits.
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
